import axios from 'axios';
import AxiosConfig from '../utils/axios';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  /**
   * GET all quote level comments by document ID.
   *
   * @param {number} documentId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getComments(documentId, applicationNamespace) {
    const axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);

    return new Promise((resolve, reject) => {
      const url = `${apiUrl}/v1/${applicationNamespace}/comments/document/${documentId}`;

      axios.get(url, axiosConfig)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  /**
   * POST a new comment.
   *
   * @param {object} param
   * @param {string} param.applicationNamespace
   * @param {number | Array} param.commentableIds
   * @param {string} param.content
   * @param {number} param.parentId
   * @returns {Promise}
   */
  postComment({
    applicationNamespace,
    commentableIds,
    content,
    parentId,
  }) {
    const axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);

    return new Promise((resolve, reject) => {
      const url = `${apiUrl}/v1/${applicationNamespace}/comments`;
      const data = {
        commentable_type: 'Document',
        content,
        parent_id: parentId,
      };

      if (applicationNamespace === 'broker_portal') {
        data.commentable_ids = Array.isArray(commentableIds) ? commentableIds : [commentableIds];
      }

      if (applicationNamespace === 'carrier_portal') {
        data.commentable_id = commentableIds;
      }

      axios.post(url, data, axiosConfig)
        .then((response) => resolve(response.data))
        .catch((e) => reject(e));
    });
  },

  /**
   * GET all comments by project ID and application namespace.
   *
   * @param {string} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getCommentsByProject(projectId, applicationNamespace) {
    const axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);

    return new Promise((resolve, reject) => {
      const url = `${apiUrl}/v1/${applicationNamespace}/comments/project/${projectId}`;

      axios.get(url, axiosConfig)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
};
